import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { trackUmengPageView } from '@/utils/umeng';

const ROUTE_PAGE_NAMES: Record<string, string> = {
  '/': 'home',
  '/model_3d': 'model_3d',
  '/about_us': 'about_us',
};

export function AnalyticsRouteBoundary() {
  const location = useLocation();

  useEffect(() => {
    trackUmengPageView({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      pageName: ROUTE_PAGE_NAMES[location.pathname] || location.pathname,
    });
  }, [location.hash, location.pathname, location.search]);

  return <Outlet />;
}
